/** Seeded ids of sales.sales_order_delivery_type: the type decides who delivers the order (N37). */
export const SalesOrderDeliveryType = { EXTERNAL: 1, INTERNAL: 2, PICK_UP: 3 };
//# sourceMappingURL=sales-order-delivery-type.js.map